import { inject, Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

import { StorageService } from 'app/shared/services/index';

const deviceIdKey = 'device-id';

@Injectable({ providedIn: 'root' })
export class DeviceInfoStorageService {
    private storage = inject(StorageService);

    getOrAddDeviceId() {
        const deviceIdFromStorage = this.storage.get<string>(deviceIdKey);
        if (deviceIdFromStorage) {
            return deviceIdFromStorage;
        }

        const deviceId = this.generateDeviceId();
        this.putDeviceIdToStorage(deviceId);
        return deviceId;
    }

    putDeviceIdToStorage(deviceId: string) {
        this.storage.store(deviceIdKey, deviceId);
    }

    private generateDeviceId(): string {
        return uuidv4();
    }
}
